import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import SmartForm from '../smart-form/smart-form.component';
import SmartList from '../smart/smart-list';
import Iconify from '../../components/Iconify';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid } from '@mui/material/';

const MultipleChoiceComponent = ({ data, onChange }) => {

    const { t } = useTranslation();

    const [displayAddChoice, setDisplayAddChoice] = useState(false);
    const [choiceData, setChoiceData] = useState();

    const validValues = data.map(d => ({ ...d, text: `${d.key} = ${d.value}` }))

    const deleteChoice = (item, items) => {
        delete validValues[item.key];
        if (onChange) {
            onChange(validValues);
        }
    };

    const closeAddChoiceModal = (result) => {
        if (result) {

            validValues.push({ key: choiceData.char, value: choiceData.text, text: `${choiceData.key} = ${choiceData.value}` });

            if (onChange) {
                onChange(validValues);
            }
        }

        setChoiceData();
        setDisplayAddChoice(false);
    };

    const addChoiceFields = [
        {
            dataField: 'char',
            text: t('Choice.Character'),
            xs: 6, sm: 4, md: 4,
            required: true,
        },
        {
            dataField: 'text',
            text: t('Choice.Text'),
            xs: 6, sm: 4, md: 4,
            required: true,
        },
    ];

    return (
        <>
            <Grid item sx={{ paddingBottom: 2 }}>
                <SmartList
                    className="field-list"
                    items={validValues}
                    title={t("Step.Choice")}
                    avatar={<Iconify icon="eva:list-fill" />}
                    header={true}
                    footer={true}
                    footerActions={[{
                        text: t('Add.Default'),
                        color: "primary",
                        onClick: () => setDisplayAddChoice(true),
                    }]}
                    search={false}
                    pagination={false}
                    toolbar={false}
                    allowDelete={true}
                    dense={false}
                    pageSize={20}
                    onDelete={(item, items) => deleteChoice(item, items)}
                />
            </Grid>

            <Dialog
                open={displayAddChoice}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogTitle>{t("Add.Choice")}</DialogTitle>
                <DialogContent>
                    <SmartForm sx={{ mt: { md: 2 } }}
                        data={choiceData}
                        fields={addChoiceFields}
                        onChange={(data) => setChoiceData(data)}
                    >
                    </SmartForm>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => closeAddChoiceModal(false)} color="primary">
                        {t("Cancel")}
                    </Button>
                    <Button onClick={() => closeAddChoiceModal(true)} color="secondary" autoFocus>
                        {t("Add.Default")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default MultipleChoiceComponent;